import { version } from "@/../package.json";
import { getPublicEnv } from "./public-env";

const serverEnvs = {
  API: {
    SWH: {
      TOKEN: process.env.API_SWH_TOKEN, // secret, server-only (read at runtime)
      URL: process.env.API_SWH_URL,
    },
  },
};

const commonEnvs = {
  ENV: getPublicEnv(
    "NEXT_PUBLIC_ENVIRONMENT",
    process.env.NEXT_PUBLIC_ENVIRONMENT
  ),
  ANALITICA_ENABLED:
    getPublicEnv(
      "NEXT_PUBLIC_ANALITICA_ENABLED",
      process.env.NEXT_PUBLIC_ANALITICA_ENABLED
    ) === "true",
  KEY: {
    AMPLITUDE: getPublicEnv(
      "NEXT_PUBLIC_AMPLITUDE_KEY",
      process.env.NEXT_PUBLIC_AMPLITUDE_KEY
    ),
    EXPERIMENT: {
      CLIENT: getPublicEnv(
        "NEXT_PUBLIC_EXPERIMENT_KEY",
        process.env.NEXT_PUBLIC_EXPERIMENT_KEY
      ),
      SERVER: getPublicEnv(
        "NEXT_PUBLIC_EXPERIMENT_SERVER_KEY",
        process.env.NEXT_PUBLIC_EXPERIMENT_SERVER_KEY
      ),
    },
    DATADOG: {
      CLIENT_TOKEN: getPublicEnv(
        "NEXT_PUBLIC_DATADOG_CLIENT_TOKEN",
        process.env.NEXT_PUBLIC_DATADOG_CLIENT_TOKEN
      ),
      APPLICATION_ID: getPublicEnv(
        "NEXT_PUBLIC_DATADOG_APPLICATION_ID",
        process.env.NEXT_PUBLIC_DATADOG_APPLICATION_ID
      ),
    },
  },
  // VERSION is per-image build metadata, so build-time inlining is correct here.
  VERSION: process.env.NEXT_PUBLIC_VERSION ?? version,
};

export { commonEnvs, serverEnvs };
